import React from "react";

export default (props) => {
  return (
    <div>
      {props.has_randomization_platform_step_3_patient ? (
        <div
          dangerouslySetInnerHTML={{
            __html: props.randomization_platform_step_3_patient_content,
          }}
        />
      ) : (<p><i>PATIENT CONSENT FORM NOT LOADED</i></p>)}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ConsentTypeGreyNuns/Texts/PatientElectronicText.js